function forFaq() {
  const accordionSections = document.querySelectorAll(".faqCntntItems");

  accordionSections.forEach((section) => {
    const accordionItemHeaders = section.querySelectorAll(
      ".accordion-item-header",
    );

    if (accordionItemHeaders.length > 0) {
      const firstAccordionItemHeader = accordionItemHeaders[0];
      const firstAccordionItemBody =
        firstAccordionItemHeader.nextElementSibling;

      firstAccordionItemHeader.classList.add("active");
      firstAccordionItemBody.style.maxHeight =
        firstAccordionItemBody.scrollHeight + "px";
    }

    accordionItemHeaders.forEach((accordionItemHeader) => {
      accordionItemHeader.addEventListener("click", (event) => {
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        accordionItemHeaders.forEach((item) => {
          if (item !== accordionItemHeader) {
            item.classList.remove("active");
            item.nextElementSibling.style.maxHeight = 0;
          }
        });
        accordionItemHeader.classList.toggle("active");
        if (accordionItemHeader.classList.contains("active")) {
          accordionItemBody.style.maxHeight =
            accordionItemBody.scrollHeight + "px";
        } else {
          accordionItemBody.style.maxHeight = 0;
        }
      });
    });
  });
}
forFaq();
{
    document.addEventListener('DOMContentLoaded', function () {
    const boxes = document.querySelectorAll('.stepsBoxesHldr .stepsBox');

    if (!boxes.length) return;

    let currentIndex = 0;
    let interval;

    function setActive(index) {
      boxes.forEach((box) => {
        box.classList.remove('boxActive');
        box.style.setProperty('--line-duration', '0s');
        const content = box.querySelector('.stepBoxCntnt');
        if (content) {
          content.style.maxHeight = '0';
        }
      });

      void document.body.offsetHeight;

      const activeBox = boxes[index];

      activeBox.style.setProperty('--line-duration', '3s');
      activeBox.classList.add('boxActive');

      const activeContent = activeBox.querySelector('.stepBoxCntnt');
      if (activeContent) {
        activeContent.style.maxHeight = activeContent.scrollHeight + 'px';
      }

      currentIndex = index;
    }

    function startAutoplay() {
      clearInterval(interval);

      interval = setInterval(() => {
        currentIndex = (currentIndex + 1) % boxes.length;
        setActive(currentIndex);
      }, 3000);
    }

    setActive(0);
    startAutoplay();

    boxes.forEach((box, index) => {
      box.addEventListener('click', () => {
        setActive(index);
        startAutoplay();
      });
    });
  });
}

{
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("#header-component");
  if (!header) return;
  let ticking = false;
  function updateMenuStyle() {
    const target = window.innerWidth <= 1100 ? "drawer" : "menu";
    const current = header.getAttribute("data-menu-style");
    if (current !== target) {
      header.setAttribute("data-menu-style", target);
    }
    ticking = false;
  }
  updateMenuStyle();
  window.addEventListener("resize", updateMenuStyle, { passive: true });
  const observer = new MutationObserver(() => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateMenuStyle);
    }
  });
  observer.observe(header, {
    attributes: true,
    attributeFilter: ["data-menu-style"]
  });
});
}

document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach((accordion) => {
    const detailsElements = accordion.querySelectorAll("details");
    detailsElements.forEach((detail) => {
      detail.addEventListener("toggle", function () {
        if (this.open) {
          detailsElements.forEach((otherDetail) => {
            if (otherDetail !== this && otherDetail.open) {
              otherDetail.open = false;
            }
          });
        }
      });
    });
  });
});